/* eslint-disable func-names */
import tmsMdmAxiosInstance from '@/tms-mdm-axios';

export const getUserAssociatedDepots = async function (userId, params) {
  try {
    return await tmsMdmAxiosInstance.get(`user/${userId}/associate_depot`, { params });
  } catch (error) {
    throw error;
  }
};
